const TIPOS_COTACAO = {
    NEGOC_ESPEC: 'Negociação Especial'
};

export default TIPOS_COTACAO;
